/** CSS custom property references for global stacking layers (see GlobalStyle). */
export const Z_INDEX = {
  topBar: 'var(--z-index-top-bar)',
  modalBase: 'var(--z-index-modal-base)',
  modalPopup: 'var(--z-index-modal-popup)',
}
